"use client";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

export default function SqMetaPixel() {
  const searchParams = useSearchParams();
  const brandId = searchParams.get("brandIds");
  const rebateId = searchParams.get("rebateIds");

  useEffect(() => {
    if (brandId === "36" && rebateId === "153") {
      console.log("Speed Queen Meta Pixel loaded...");
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js"
      );

      fbq("init", "948167505354989");
      fbq("track", "PageView");
    }
  }, [brandId, rebateId]);

  return null;
}
